export class NextJSMiddleware {
  static create() {
    return () => {
      // noop
    }
  }
}
